module.exports = __webpack_public_path__ + "static/media/cat_wind.60d36553.png";